import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

/**
 * JSON-LD for search engines. Keep this strictly factual: no ratings, prices,
 * or features the site does not actually have (fabricated review markup is a
 * Google structured-data policy violation).
 */
const StructuredData = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'ResearchOrganization',
          '@id': 'https://duran.ai/#organization',
          name: 'Duran',
          url: 'https://duran.ai/',
          logo: {
            '@type': 'ImageObject',
            url: 'https://duran.ai/icon-512.png',
          },
          description: t('seo.description'),
          sameAs: ['https://twitter.com/duranai', 'https://linkedin.com/company/duran-ai'],
        },
        {
          '@type': 'WebSite',
          '@id': 'https://duran.ai/#website',
          url: 'https://duran.ai/',
          name: t('seo.title'),
          description: t('seo.description'),
          publisher: { '@id': 'https://duran.ai/#organization' },
          inLanguage: i18n.language,
        },
        {
          '@type': 'WebPage',
          '@id': 'https://duran.ai/#webpage',
          url: 'https://duran.ai/',
          name: t('seo.title'),
          description: t('seo.description'),
          isPartOf: { '@id': 'https://duran.ai/#website' },
          about: { '@id': 'https://duran.ai/#organization' },
          inLanguage: i18n.language,
        },
      ],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
  }, [t, i18n.language]);

  return null;
};

export default StructuredData;
